import React from "react";
import utils from "utils";
import api from "utils/api";
import "./VideoConsultation.scss";
import { CONSTANTS } from "utils/constant";
import { message } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import {
    Row,
    Col,
    Form,
    Select, 
    DatePicker,
    Popconfirm,
    Button, List
} from "antd";
import { FOLLOWUP_NOTES } from 'Common/constant';
import dayjs from "dayjs";
import configureStore from "store/index";
const { store } = configureStore();
class FollowUp extends React.Component {
    formConsultation = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            autoNoConsultation: this.props.autoNoConsultation,
            selected_time:"",
            buttonLoading : false,
            doctor_time_zone_offset:store.getState().loginReducer?.user_details?.time_zone_offset_in_min,
            convertedDate:"",
            open_popup:false
        };
        this.formConsultation=React.createRef();
    }
    componentDidMount(){
        this.props.formAction(false)
        // this.getConsultationStatus()
        this.followupConsultationRetain()
        this.setState({patient_off_set:this.props.patientOffSet})
    }
    getConsultationStatus() {
        api.get_consultation_status({ "appointment_id": this.props.data.appointment_id})
            .then((response) => {
                this.setState({
                    buttonLoading: false,
                    is_prescription_done: response.data.data.is_prescription,
                    is_casesheet: response.data.data.is_casesheet,
                    is_dsm: response.data.data.is_dsm,
                    is_mhe: response.data.data.is_mhe,
                    is_theraphy: response.data.data.is_theraphy,
                    is_doctor_referral: response.data.data.doctor_referral,     
                    is_protective_factor: response.data.data.is_protective_factor,
                    is_dot: response.data.data.is_dot,
                    is_sos: response.data.data.is_sos,
                    is_assessment :response.data.data.is_assessment,
                })
                if(this.state.is_followup_consultation){
                    this.setState({})
                }
                this.props.handleAutoNoConsultation(  !response.data.data.is_followup_consultation)
            })
            .catch((err) => {

            })
    }
    // onConsultationRadioChange = (e) => {
    //     this.setState({
    //         consultationValue: e.target.value,
    //     });
    //     if (this.state.consultationValue === 2) {
    //         this.formConsultation.current?.resetFields();
    //         this.tabsWithChanges("remove", "3");
    //     }
    //     if (this.state.consultationValue === 1) {
    //         this.tabsWithChanges("add", "3");
    //     }
    // };
   onCheckConsultation = () => {
        if (this.props.consultationValue === 1) {
            return false;
        } else {
            return true;
        }
    };
    handleDoctorDatesChange(formData) {
        this.formConsultation.current?.setFieldsValue({consultationTime : null})
        this.setState({selectedSlot:""})
        if (!formData) return
        if(!(dayjs(utils.TimezoneOffsetConversion()).format('DD/MM/YYYY') == dayjs(formData).format('DD/MM/YYYY'))){
            formData = dayjs(formData).format('YYYY-MM-DD 00:00:00')
        }else{
            formData =  utils.FormatDate(utils.TimezoneOffsetConversion(),"UTC","days")
        }
        let data = {
            doctor_id: this.props?.doc_api_id,
            appointment_date_time: formData,
            selected_time:'',
            patient_id: this.props.patient_id,
        };
        api
            .get_doctor_slots(data)
            .then((res) => {
                if (res.data?.status == 200) {
                    this.setState({
                        doctorAvaliableSlots: res.data?.data.results,
                    });
                }
            })
            .catch((err) => { });
        
    }
    handleDoctorSlotsChange(formData) {
        this.setState({
            selectedSlot: formData,
            selected_time:formData.split(" ")[1]
        });
        if(this.state.patient_off_set!==this.state.doctor_time_zone_offset)
        {
            let convertedVal = -1 * this.state.doctor_time_zone_offset ;
            let convertDate = dayjs.utc(formData).add(convertedVal,'minute').add(this.state.patient_off_set,'minute')
            this.setState({convertedDate:convertDate})
        }
    }
    addConsultationSubmit(formData) {
        this.setState({buttonLoading: true})
        //if (this.state.consultationValue === 2) {
        let result = this.props.consultationValue === 2 ? true : false;
        let consultationFormData = {
            appointment_id: this.props.appointment_id,
            appointment_date_time: formData?.consultationTime || "",
            next_consultation: result,
        };
       
        api
            .next_consultation_submit(consultationFormData)
            .then((res) => {
                if (res.data?.status == 200) {
                    this.setState({
                        autoNoConsultation: false,
                        consultationValue: 1
                    })
                    message.success(res.data?.message, ErrorDuration);
                    this.setState({open_popup:false,buttonLoading: false,})
                    this.followupConsultationRetain();
                    this.props.formAction(false)
                    this.props.handleAutoNoConsultation(false)
                    this.getConsultationStatus()
                }else{
                    this.setState({buttonLoading: false,open_popup:false})
                }
            })
            .catch((err) => { });
        //} else {
        //this.onchangeTab("3");
        //}
        // this.props.location.state.setModule('OTP', { from: 'forgotPassword' });
    }
   
    followupConsultationRetain() {
        let data = {
            app_id: this.props.data.appointment_id,
            type: "followup_consultation"
        }
        api.get_consultation_details(data)
            .then((response) => {
                this.setState({ followupConsultationData: response.data.data.results.followup_consultation[0] });
            })
            .catch(() => {

            })
    }

    handlePopover(){
        if(this.props.consultationValue=="1"){
            this.setState({open_popup:true})
        }else{
            if(this.state.selectedSlot){
                this.setState({open_popup:true})
            }else{
                this.formConsultation.current.submit()
            }
        }
    }
   

    render() {

        return (
            <div className="video-consultation-wrapper">

                <Form
                    name="addConsultation"
                    ref={this.formConsultation}
                    layout="vertical"
                    initialValues={{ remember: true }}
                    onFinish={this.addConsultationSubmit.bind(this)}
                    onFieldsChange={() => this.props.formAction(true)}
                    style={{margin:"0px 21px"}}
                    //onValuesChange={()=>this.tabsWithChanges("add","3") }
                    autoComplete="off"
                    labelCol={{
                        span: 20,
                    }}
                    disabled={this.props.consultationValue == "1" ? true:false}
                    // disabled={!this.props.autoNoConsultation}

                    wrapperCol={{
                        span: 12,
                    }}
                >
                    {/* <Row gutter={16}>
                        <Col xs={24} lg={10}> */}
                            <Row gutter={16}>
                                
                                <Col span={24}
                                // style={{ marginTop: 25 }}
                                >
                                    
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <h3 className="next-appointment">{CONSTANTS.NEXT_APPOINTMENT_DATE}</h3>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    colon='true'
                                                    label={`${CONSTANTS.NEXT_APPOINTMENT}${this.props.consultationValue === 2 ? '::' : ''}`}
                                                    labelAlign="left"
                                                    name="consultationDate"
                                                    rules={[
                                                        {
                                                            required:
                                                                this.onCheckConsultation(),
                                                            message: `${CONSTANTS.PLEASE_SELECT_DATE}`,
                                                        },
                                                    ]}
                                                >
                                                    {this.state.followupConsultationData ? <div
                                                        className="follow-up-next-aappointment-date"
                                                    // style={{ fontWeight: "bold", fontSize: "14px", marginTop: "2px" }}
                                                    >
                                                        {utils.FormatDate(this.state.followupConsultationData.followup_date_time, "DATE_1")}
                                                    </div> : <DatePicker
                                                        className="follow-up-datepicker"
                                                        // style={{ width: "150px" }}
                                                       
                                                        disabledDate={(current) =>{
                                                            let currentDate = dayjs(current.format('YYYY-MM-DD'));
                                                            let userDate = utils.TimezoneOffsetConversionForPatient(this.state.doctor_time_zone_offset).startOf("day").format('YYYY-MM-DD');
                                                            let user90Date = utils.TimezoneOffsetConversionForPatient(this.state.doctor_time_zone_offset).add(90, "days").startOf("day").format('YYYY-MM-DD');
                                                            return(!currentDate.isBetween(userDate,user90Date,null,'[]'))
                                                        }}
                                                        inputReadOnly={true}
                                                        superPrevIcon={null}
                                                        superNextIcon={null}
                                                        value={null}
                                                        showToday={false}
                                                        onChange={this.handleDoctorDatesChange.bind(this)}
                                                        placeholder={["Select Date"]}
                                                        format="DD/MM/YYYY"
                                                    />}
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <h3 className="appointment-time">{CONSTANTS.APPOINTMENT_TIME}</h3>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    label={`${CONSTANTS.YOUR_APPOINTMENT_TIME}${this.props.consultationValue === 2 ? '::' : ''}`}
                                                    labelAlign="left"
                                                    name="consultationTime"
                                                    rules={[
                                                        {
                                                            required:
                                                                this.onCheckConsultation(),
                                                            message: `${CONSTANTS.PLEASE_SELECT_TIME}`,
                                                        },
                                                    ]}
                                                >
                                                    {this.state.followupConsultationData ? <div
                                                        className="follow-up-next-aappointment-time"
                                                    // style={{ontWeight: "bold", fontSize: "14px", marginTop: "2px" }}
                                                    >
                                                        {utils.FormatDate(this.state.followupConsultationData.followup_date_time, "TIME_1")}
                                                    </div> : <Select style={{width:"100%"}} className="select-time-style"
                                                        placeholder={CONSTANTS.SELECT_TIME}
                                                      value={this.state.selected_time}
                                                        onChange={
                                                            this.handleDoctorSlotsChange.bind(this)
                                                        }

                                                    >
                                                        {(
                                                            this.state
                                                                .doctorAvaliableSlots || []
                                                        ).map((m, i) => (
                                                            <Select.Option
                                                                key={i}
                                                                value={m}
                                                                // disabled={utils.TimezoneOffsetConversion().isAfter(
                                                                //     dayjs(m)
                                                                // )}
                                                            >
                                                                {utils.FormatDate(
                                                                    m,
                                                                    "TIME_1"
                                                                )}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>}
                                                </Form.Item>
                                               {this.state.selected_time&&this.state.convertedDate&&<p style={{marginTop:"20px", color:"#F38744"}}>* The appointment is scheduled at {utils.FormatDate(this.state.convertedDate, "DATE_TIME_3")}, in patient's time zone.</p>} 
                                            </Col>
                                        </Row>
                                
                                </Col>
                                <Col
                                    span={24}
                                    className="follow-up-submit-btn"
                                // style={{
                                //   textAlign: "right",
                                //   marginTop: 20,
                                // }}
                                >
                                    {/* {this.state.autoNoConsultation && !this.state.followupConsultationData && <Button
                                        type="primary"
                                        shape="round"
                                        htmlType="submit"
                                    >
                                        Submit <ArrowRightOutlined />
                                    </Button>} */}
                                </Col>
                            </Row>
                        {/* </Col>
                    </Row> */}
                </Form>
                {this.props.oneSessionPlan && <div style={{margin:"0px 21px"}}>
                    Note:
                    <List
                        dataSource={FOLLOWUP_NOTES}
                        renderItem={(item,i) => (
                            <List.Item style={{ borderBottom: 'none', color: 'orange', padding: "4px 12px" }}>
                            {/* {i+1}. */}
                             {item}
                            </List.Item>
                        )}
                    />
                </div>}
                <div className="submit-button-wrapper" style={{textAlign:"end"}}>
                {this.state.autoNoConsultation && !this.state.followupConsultationData && 
                <div className="confirm-follow-up">
                  <Popconfirm
                  placement="topLeft"
                 title={
                    <div  style={{width:"350px",maxWidth:"350px"}}className="chat-close-pop-title">
                    {this.props?.consultationValue==2?
                    <>{`${CONSTANTS.CONFIRM_FOLLOW_UP}`}

                       {this.state.selected_time&&this.state.convertedDate&&<p style={{marginTop:"20px", color:"#F38744"}}>* The appointment is scheduled at {utils.FormatDate(this.state.convertedDate, "DATE_TIME_3")}, in patient's time zone.</p>} 
                   </>:<>{`${CONSTANTS.COFIRM_NO_FOLLOW_UP}`}</>}
                        </div>
                 }
                 onCancel={()=>this.setState({open_popup:false})}
                 onConfirm={(e)=>this.formConsultation.current.submit()}
                  okText="Ok"
                  footer={false}
                  open={this.state.open_popup}
                
                >
                    <Button type="primary" onClick={()=>this.handlePopover()} loading={this.state.buttonLoading}>{CONSTANTS.SUBMIT} <ArrowRightOutlined /></Button>
                </Popconfirm>
                
              </div>
                }
            </div>

            </div >
        );
    }
}

export default (FollowUp);
// export default withRouter(VideoConsultation);